export default "__VITE_ASSET__Bza1Ir0c__"